import { render } from "./message-file.vue?vue&type=template&id=3f9a76df&scoped=true&ts=true"
import script from "./message-file.vue?vue&type=script&lang=ts"
export * from "./message-file.vue?vue&type=script&lang=ts"

import "./message-file.vue?vue&type=style&index=0&id=3f9a76df&lang=scss&scoped=true"

import exportComponent from "D:\\phpstudy_pro\\WWW\\tengxunshipin\\chat-example\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f9a76df"]])

export default __exports__